import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import classnames from 'classnames';
import { withTheme } from 'common/styling/theme';
import { BasketIcon } from 'common';
import { BasicModal, DefaultButton } from 'common/components';
import { staticStyles, getDynamicStyles } from './style';
import { getDepositRequisitesList, getWithdrawRequisitesList, deleteRequisite } from '../../_redux';

const SavedMethods = ({
  theme,
  typeOperation,
  depositRequisites,
  depositRequisitesLoaded,
  withdrawRequisites,
  withdrawRequisitesLoaded,
  getDepositRequisitesList,
  getWithdrawRequisitesList,
  handleSavedMethodClick,
  savedRequisiteId,
  deleteRequisite,
}) => {
  const dynamicStyles = Object.keys(theme).length ? getDynamicStyles(theme) : ` `;
  const [isConfirmModalOpened, setIsConfirmModalOpened] = useState(false);
  const [currentSavedMethodId, setCurrentSavedMethodId] = useState(null);

  useEffect(() => {
    if (typeOperation === 'deposit') {
      getDepositRequisitesList();
    }
    if (typeOperation === 'withdraw') {
      getWithdrawRequisitesList();
    }
  }, [typeOperation, getDepositRequisitesList, getWithdrawRequisitesList]);

  const handleConfirmModalOpen = () => {
    setIsConfirmModalOpened(open => !open);
  };

  const handleDeleteClick = id => {
    setCurrentSavedMethodId(id);
    handleConfirmModalOpen();
  };

  const handleDeletePaymentMethod = () => {
    deleteRequisite({ id: currentSavedMethodId, typeOperation });
    handleConfirmModalOpen();
  };

  const requisites = typeOperation === 'deposit' ? depositRequisites : withdrawRequisites;

  const loaded = typeOperation === 'deposit' ? depositRequisitesLoaded : withdrawRequisitesLoaded;

  return (
    <div className="SavedMethods">
      {loaded && requisites.length > 0 && (
        <>
          <FormattedMessage id="savedMethods">{txt => <h3 className="SavedMethods__title">{txt}</h3>}</FormattedMessage>
          <div className="SavedMethods__requisites">
            {requisites.map(requisite => (
              <div key={requisite.id} className="SavedMethods__requisites-container">
                <button
                  type="button"
                  className="SavedMethods__requisites-item-remove"
                  onClick={e => {
                    e.stopPropagation();
                    handleDeleteClick(requisite.id);
                  }}>
                  <BasketIcon />
                </button>
                <button
                  type="button"
                  className={classnames('SavedMethods__requisites-item', {
                    'SavedMethods__requisites-item--active': savedRequisiteId === requisite.id,
                  })}
                  onClick={() => handleSavedMethodClick(requisite.id, requisite.paymentMethod?.title)}>
                  <div className="SavedMethods__requisites-item-icon">
                    <img src={requisite.paymentMethod?.iconUrl} alt="" />
                  </div>
                  <div className="SavedMethods__requisites-item-info">
                    <h3 className="SavedMethods__requisites-item-info--title">{requisite.paymentMethod?.title}</h3>
                    <p className="SavedMethods__requisites-item-info--card-number">
                      {requisite.primaryRequisite || '-'}
                    </p>
                  </div>
                </button>
              </div>
            ))}
          </div>
        </>
      )}

      <BasicModal isOpen={isConfirmModalOpened} onRequestClose={handleConfirmModalOpen} captionId="deletePaymentMethod">
        <div className="SavedMethods__confirm-modal">
          <FormattedMessage id="savedMethodsDeleteConfirmation">{txt => txt}</FormattedMessage>
          <div className="SavedMethods__confirm-modal-actions">
            <DefaultButton textId="justDelete" type="button" butColor="error" onClick={handleDeletePaymentMethod} />
            <DefaultButton textId="justCancel" type="button" onClick={handleConfirmModalOpen} />
          </div>
        </div>
      </BasicModal>

      <style jsx>{staticStyles}</style>
      <style jsx>{dynamicStyles}</style>
    </div>
  );
};

SavedMethods.propTypes = {
  theme: PropTypes.object,
  typeOperation: PropTypes.string.isRequired,
  depositRequisites: PropTypes.array.isRequired,
  depositRequisitesLoaded: PropTypes.bool.isRequired,
  withdrawRequisites: PropTypes.array.isRequired,
  withdrawRequisitesLoaded: PropTypes.bool.isRequired,
  getDepositRequisitesList: PropTypes.func.isRequired,
  getWithdrawRequisitesList: PropTypes.func.isRequired,
  handleSavedMethodClick: PropTypes.func.isRequired,
  savedRequisiteId: PropTypes.number,
  deleteRequisite: PropTypes.func.isRequired,
};

SavedMethods.defaultProps = {
  theme: {},
  savedRequisiteId: null,
};

export default compose(
  withTheme(),
  connect(
    state => ({
      depositRequisites: state.client.payments.depositRequisites,
      depositRequisitesLoaded: state.client.payments.depositRequisitesLoaded,
      withdrawRequisites: state.client.payments.withdrawRequisites,
      withdrawRequisitesLoaded: state.client.payments.withdrawRequisitesLoaded,
    }),
    {
      getDepositRequisitesList: () => getDepositRequisitesList.request(),
      getWithdrawRequisitesList: () => getWithdrawRequisitesList.request(),
      deleteRequisite: data => deleteRequisite.request(data),
    }
  )
)(SavedMethods);

export { SavedMethods };
